module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/symbol/iterator"
// module id = 16
// module chunks = 0